import React from 'react'
import { formatHour, formatMoney } from '../../../helpers/utils'
import {
  formatPendingSettlementCount,
  renderPendingSettlementLabel,
  SETTLEMENT_STATUS_HEADER
} from '../helpers/pendingSettlement'
import { createReportDetailsTab } from './createReportDetailsTab'

const HEADERS = [
  { label: 'CÓDIGO', description: 'Número de identificación del usuario' },
  { label: 'USUARIO', description: 'Nombre del usuario' },
  { label: 'ÚLTIMA ACTIVIDAD', description: 'Hora de última actividad registrada' },
  { label: 'VISITAS REALIZADAS', description: 'Cantidad total de visitas registradas' },
  { label: 'VISITAS FUERA DE RUTA', description: 'Visitas que no estaban asignadas' },
  { label: 'EFECTIVIDAD', description: 'Porcentaje de visitas efectivas' },
  {
    label: 'ACTIVIDADES DENTRO DE GEOCERCA',
    description: 'Actividades dentro de la zona permitida'
  },
  { label: 'ANULADOS', description: 'Cobros anulados hechos por el usuario' },
  SETTLEMENT_STATUS_HEADER,
  {
    label: 'COBROS PENDIENTES POR LIQUIDAR',
    description: 'Indica si el usuario tiene cobros del día que todavía no ha liquidado, incluso si ya liquidó otros cobros anteriormente ese mismo día'
  },
  { label: 'TOTAL MONTOS', description: 'Total de cobros hechos por el usuario' }
]

function renderRow(model, { isSingleDayRange = true } = {}) {
  return (
    <>
      <td>{model.user_uid}</td>
      <td>{model.user_name}</td>
      <td className="text-center">{formatHour(model.charge_last_visit)}</td>
      <td className="text-center">
        {model.total_visited_clients}/{model.all_executed_clients}
      </td>
      <td className="text-center">{model.out_of_route_clients}</td>
      <td className="text-center">{model.charge_percent_effectiveness}%</td>
      <td className="text-center">
        {model.charge_location_effective_count}/{model.charge_location_available_count}
      </td>
      <td className="text-center">{model.charge_cancelled_count}</td>
      <td className="text-center">
        {renderPendingSettlementLabel(model.settlement_status, isSingleDayRange)}
      </td>
      <td className="text-center">
        {formatPendingSettlementCount(model.pending_charges_settlement_count, isSingleDayRange)}
      </td>
      <td className="text-center">{formatMoney(model.total_charge)}</td>
    </>
  )
}

export default createReportDetailsTab({
  displayName: 'ReportChargesTab',
  headers: HEADERS,
  renderRow,
  supportsSettlement: true
})
